import Config from './config.json';

export default Config;